import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { DealerFeature } from '../+state';
import { Dealer } from '../api/api-types';

type MaybePromise<T> = T | Promise<T>;
export const setHighlightbannerConfig = (
    calcBanner: (
        highlightBanner: NonNullable<Dealer['highlightBanner']>,

        route: ActivatedRouteSnapshot,
    ) => MaybePromise<{ showGlobalBanner: boolean; showDealerBanner: boolean }> | undefined,
) => {
    return {
        highlightBanner: async (route: ActivatedRouteSnapshot) => {
            const store = inject(Store);
            const dealer = await firstValueFrom(store.select(DealerFeature.state.selectLoadedDealer));

            const { highlightBanner } = dealer;
            if (!highlightBanner) {
                return {
                    highlightBanner: null,
                };
            }

            return calcBanner(highlightBanner, route);
        },
    };
};
